import { useLocation } from "react-router-dom";
import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import Transition from "../../../components/transition/Transition";
import { useEffect, useState } from "react";
import ProjectDetailsHeader from "./projectDetailsHeader/ProjectDetailsHeader";
import ProjectDetailsThumbnail from "./projectDetailsThumbnail/ProjectDetailsThumbnail";
import ProjectDetailsCarousell from "./projectDetailsCarousell/ProjectDetailsCarousell";
import ProjectDetailsDemo from "./projectDetailsDemo/ProjectDetailsDemo";

export default function ProjectDetails() {

    const [project, setProject] = useState({});
    const [ready, setReady] = useState(false);
    
    const location = useLocation();

    useEffect(() => {
        const { selectedProject = null } = location.state;

        if(selectedProject){
            setProject(selectedProject);
            setReady(true);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOnClick = (e) => {
        e.preventDefault();

        if(project.link){
            window.open(project.link, '_blank', 'noopener,noreferrer');
        }
    }



    if(ready){
        return(
            <Transition emojiName={project.emoji??"banana"}>


                <ProjectDetailsHeader
                    title={project.title}
                    emoji={project.emoji}
                    techStack={project.tech}
                    description={project.description}
                />

                <ProjectDetailsThumbnail 
                    src={project.thumbnail}
                    alt={project.thumbnailAlt}
                />


                {
                    project.screenshots && (
                        <ProjectDetailsCarousell 
                            gradientStart={project.gradient[0]}
                            gradientEnd={project.gradient[1]}
                            screenshots={project.screenshots}
                        />
                    )
                }

                {
                    project.demo&& (
                        <ProjectDetailsDemo 
                            src={project.demo}
                            alt={project.demoAlt}
                            isVertical={false}
                        />
                    )
                }

                {
                    project.mobileScreenshots && (
                        <ProjectDetailsCarousell 
                            gradientStart={project.gradient[0]}
                            gradientEnd={project.gradient[1]}
                            screenshots={project.mobileScreenshots}
                        />
                    )
                }

                {
                    project.demoMobile && (
                        <ProjectDetailsDemo 
                            src={project.demoMobile}
                            alt={project.demoMobileAlt}
                            isVertical={true}
                        />
                    )
                }

                {
                    project.link && (
                        <div
                            className="
                                flex
                                justify-center
                                my-16
                            "
                        >
                            <button
                                onClick={handleOnClick}
                                className="
                                    bg-body-bg-dark
                                    dark:bg-body-bg-light
                                    text-body-text-dark
                                    dark:text-body-text-light
                                    font-semibold
                                    tracking-wider
                                    text-xl
                                    p-5
                                    rounded-3xl
                                    text-nowrap
                                    flex
                                    items-center

                                    transition-all
                                    hover:scale-110
                                "
                            >
                                See The Project
                                &nbsp;
                                <EmojiProvider data={emojiData}>
                                    <Emoji className="inline" name="satellite-antenna" width={24}/>
                                </EmojiProvider>
                            </button>
                        </div>
                    )
                }

            </Transition>
        );
    }
}